import { render, staticRenderFns } from "./framework-sidebar-menu-item-group.vue?vue&type=template&id=107630b0&"
import script from "./framework-sidebar-menu-item-group.vue?vue&type=script&lang=js&"
export * from "./framework-sidebar-menu-item-group.vue?vue&type=script&lang=js&"
import style0 from "./framework-sidebar-menu-item-group.vue?vue&type=style&index=0&id=107630b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports